import React from 'react';
import LoginScreen from './LoginScreen';

const Landing = () => {

  return (
    <LoginScreen />
  )
}

export default Landing;
